import { useQuery } from '@apollo/client'
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { useKeycloak } from '@react-keycloak/web'
import React from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { CancelButton } from '../component/Buttons'
import { FETCH_WORKSPACES } from '../graphql/queries'
import { useWorkspace, Workspace } from '../providers/workspace'

const WorkspaceCard = styled.div`
  display: flex;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 8px;
  cursor: pointer;
`

export const WorkspaceSelector: React.FC = () => {
  const {
    workspaceSelectorOpen,
    setSelectedWorkspace,
    setWorkspaceSelectorOpen,
    redirectTo,
    selectedWorkspace
  } = useWorkspace(
    ({
      workspaceSelectorOpen,
      setSelectedWorkspace,
      setWorkspaceSelectorOpen,
      redirectTo,
      selectedWorkspace
    }) => ({
      workspaceSelectorOpen,
      setSelectedWorkspace,
      setWorkspaceSelectorOpen,
      redirectTo,
      selectedWorkspace
    })
  )
  const history = useHistory()
  const { keycloak } = useKeycloak()
  const { data, loading } = useQuery<{ myWorkspaces: Workspace[] }>(
    FETCH_WORKSPACES,
    {
      skip: !!selectedWorkspace || !keycloak.authenticated
    }
  )
  const workspaces = data?.myWorkspaces || []

  async function handleSelectWorkspace(selectedWorkspace: Workspace) {
    setSelectedWorkspace(selectedWorkspace)

    history.push(
      redirectTo && redirectTo !== '/nav'
        ? redirectTo
        : '/nav/catarata/visao-normal'
    )
    setWorkspaceSelectorOpen(false)
  }

  React.useEffect(() => {
    if (selectedWorkspace) return
    if (workspaces.length === 1) {
      handleSelectWorkspace(workspaces[0])
    }
  }, [workspaces])

  if (loading || workspaces.length === 1) return null

  return (
    <Dialog open={workspaceSelectorOpen}>
      <DialogTitle>Selecione o workspace</DialogTitle>
      <DialogContent style={{ width: 600 }}>
        {workspaces.length === 0 && (
          <>
            <h2 style={{ color: 'red' }}>
              Seu usuário não possui acesso a nenhuma conta.
            </h2>
            <CancelButton
              style={{ marginTop: 20 }}
              onClick={() => keycloak.logout()}
            >
              Trocar usuário
            </CancelButton>
          </>
        )}
        {workspaces?.map(workspace => (
          <WorkspaceCard
            onClick={() => handleSelectWorkspace(workspace)}
            key={workspace._id}
          >
            {workspace.name}
          </WorkspaceCard>
        ))}
      </DialogContent>
    </Dialog>
  )
}
